import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { uhxVariantIds } from 'content/products/uhx/variantIds';

export const UhxShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.IN].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Year1,
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/42178684354630:1', // TODO
            pricePerYear: 2988,
            price: 2988,
            pricePerMonth: 249,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.IN].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Year2,
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/42189944815686:1', // TODO
            pricePerYear: 2220,
            price: 4440,
            pricePerMonth: 185,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.IN].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Month3,
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/44331688067142:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.AE].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Year1,
            checkouturl: 'https://ultrahuman.shop/cart/51627504140659:1', // TODO
            pricePerYear: 144,
            price: 144,
            pricePerMonth: 12,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.AE].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Year2,
            checkouturl: 'https://ultrahuman.shop/cart/51628981518707:1', // TODO
            pricePerYear: 96,
            price: 192,
            pricePerMonth: 8,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.AE].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Month3,
            checkouturl: 'https://ultrahuman.shop/cart/62359756374387:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Year1,
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/42199560552508:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Year2,
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/42216495448124:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Month3,
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/40908419989564:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.US].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Year1,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41322443374688:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.US].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Year2,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41333972074592:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.US].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Month3,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/40200379727968:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.GB].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.GB].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.GB].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },

        [ShopifyStore.EU]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.EU].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.EU].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.EU].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AU]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.AU].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 59,
            price: 59,
            pricePerMonth: 4.92,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.AU].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 44.5,
            price: 89,
            pricePerMonth: 3.71,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.AU].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.CA]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.CA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Year1,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41322443374688:1',
            pricePerYear: 49,
            price: 49,
            pricePerMonth: 4.08,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.CA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Year2,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41333972074592:1',
            pricePerYear: 39.5,
            price: 79,
            pricePerMonth: 3.29,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.CA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Month3,
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/40200379727968:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.SA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 155,
            price: 155,
            pricePerMonth: 12.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.SA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 99.5,
            price: 199,
            pricePerMonth: 16.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.SA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ZA]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 749,
            price: 749,
            pricePerMonth: 62.4,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 499.5,
            price: 999,
            pricePerMonth: 41.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.JP]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.JP].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 6500,
            price: 6500,
            pricePerMonth: 541,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.JP].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 4900,
            price: 9800,
            pricePerMonth: 408,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.JP].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.MX].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 671,
            price: 671,
            pricePerMonth: 55.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.MX].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 503,
            price: 1006,
            pricePerMonth: 41.9,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.MX].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
      }
    : {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.IN].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Year1,
            checkouturl: '', // TODO
            pricePerYear: 2988,
            price: 2988,
            pricePerMonth: 249,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.IN].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Year2,
            checkouturl: '', // TODO
            pricePerYear: 2220,
            price: 4440,
            pricePerMonth: 184.5,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.IN].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.IN].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.AE].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Year1,
            checkouturl: '', // TODO
            pricePerYear: 144,
            price: 144,
            pricePerMonth: 12,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.AE].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Year2,
            checkouturl: '', // TODO
            pricePerYear: 192,
            price: 96,
            pricePerMonth: 8,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.AE].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.AE].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Year1,
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Year2,
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.ROW].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.ROW].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.US].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Year1,
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.US].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Year2,
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.US].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.US].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.GB].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Year1,
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.GB].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Year2,
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.GB].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.GB].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },

        [ShopifyStore.EU]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.EU].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Year1,
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.EU].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Year2,
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.EU].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.EU].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AU]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.AU].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Year1,
            checkouturl: '',
            pricePerYear: 59,
            price: 59,
            pricePerMonth: 4.92,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.AU].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Year2,
            checkouturl: '',
            pricePerYear: 44.5,
            price: 89,
            pricePerMonth: 3.71,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.AU].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.AU].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.CA]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.CA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Year1,
            checkouturl: '',
            pricePerYear: 49,
            price: 49,
            pricePerMonth: 4.08,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.CA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Year2,
            checkouturl: '',
            pricePerYear: 39.5,
            price: 79,
            pricePerMonth: 3.29,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.CA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.CA].Month3,
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.SA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 155,
            price: 155,
            pricePerMonth: 12.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.SA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 99.5,
            price: 199,
            pricePerMonth: 16.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.SA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.SA].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.MX].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 671,
            price: 671,
            pricePerMonth: 55.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.MX].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 503,
            price: 1006,
            pricePerMonth: 41.9,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.MX].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.MX].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ZA]: {
          // ZA uses EU/GB variants
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 749,
            price: 749,
            pricePerMonth: 62.4,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 499.5,
            price: 999,
            pricePerMonth: 41.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.ZA].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.ZA].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.JP]: {
          // JP uses EU/GB variants
          Year1: {
            variantId: uhxVariantIds[ShopifyStore.JP].Year1,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Year1,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 6500,
            price: 6500,
            pricePerMonth: 541,
            validityInYears: 1,
          },
          Year2: {
            variantId: uhxVariantIds[ShopifyStore.JP].Year2,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Year2,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 4900,
            price: 9800,
            pricePerMonth: 408,
            validityInYears: 2,
          },
          Month3: {
            variantId: uhxVariantIds[ShopifyStore.JP].Month3,
            alternateVariantId: uhxVariantIds[ShopifyStore.JP].Month3,
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
      };

export const standaloneUhxShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/42534136250438',
            alternateVariantId: 'gid://shopify/ProductVariant/42534136250438',
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/42534136250438:1', // TODO
            pricePerYear: 2988,
            price: 2988,
            pricePerMonth: 249,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/42534136414278',
            alternateVariantId: 'gid://shopify/ProductVariant/42534136414278',
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/42534136414278:1', // TODO
            pricePerYear: 2220,
            price: 4440,
            pricePerMonth: 185,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/44331688067142',
            alternateVariantId: 'gid://shopify/ProductVariant/44331688067142',
            checkouturl:
              'https://ultrahumanstore.myshopify.com/cart/44331688067142:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/52402928222579',
            alternateVariantId: 'gid://shopify/ProductVariant/52402928222579',
            checkouturl: 'https://ultrahuman.shop/cart/52402928222579:1', // TODO
            pricePerYear: 144,
            price: 144,
            pricePerMonth: 12,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/52402928681331',
            alternateVariantId: 'gid://shopify/ProductVariant/52402928681331',
            checkouturl: 'https://ultrahuman.shop/cart/52402928681331:1', // TODO
            pricePerYear: 96,
            price: 192,
            pricePerMonth: 8,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/62359756374387',
            alternateVariantId: 'gid://shopify/ProductVariant/62359756374387',
            checkouturl: 'https://ultrahuman.shop/cart/62359756374387:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/42570329587772',
            alternateVariantId: 'gid://shopify/ProductVariant/42570329587772',
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/42570329587772:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/42570334208060',
            alternateVariantId: 'gid://shopify/ProductVariant/42570334208060',
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/42570334208060:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40908419989564',
            alternateVariantId: 'gid://shopify/ProductVariant/40908419989564',
            checkouturl:
              'https://ultrahuman-us.myshopify.com/cart/40908419989564:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41616863887456',
            alternateVariantId: 'gid://shopify/ProductVariant/41616863887456',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41616863887456:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41616864116832',
            alternateVariantId: 'gid://shopify/ProductVariant/41616864116832',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41616864116832:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40200379727968',
            alternateVariantId: 'gid://shopify/ProductVariant/40200379727968',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/40200379727968:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },

        [ShopifyStore.EU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 59,
            price: 59,
            pricePerMonth: 4.92,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 44.5,
            price: 89,
            pricePerMonth: 3.71,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.CA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41616863887456',
            alternateVariantId: 'gid://shopify/ProductVariant/41616863887456',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41616863887456:1',
            pricePerYear: 49,
            price: 49,
            pricePerMonth: 4.08,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41616864116832',
            alternateVariantId: 'gid://shopify/ProductVariant/41616864116832',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/41616864116832:1',
            pricePerYear: 39.5,
            price: 79,
            pricePerMonth: 3.29,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40200379727968',
            alternateVariantId: 'gid://shopify/ProductVariant/40200379727968',
            checkouturl:
              'https://stelcore-x-ultrahuman.myshopify.com/cart/40200379727968:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/50437365563710',
            alternateVariantId: 'gid://shopify/ProductVariant/50437365563710',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 155,
            price: 155,
            pricePerMonth: 12.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/50461136355646',
            alternateVariantId: 'gid://shopify/ProductVariant/50461136355646',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 99.5,
            price: 199,
            pricePerMonth: 16.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/50437365563710',
            alternateVariantId: 'gid://shopify/ProductVariant/50437365563710',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 671,
            price: 671,
            pricePerMonth: 55.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/50461136355646',
            alternateVariantId: 'gid://shopify/ProductVariant/50461136355646',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 503,
            price: 1006,
            pricePerMonth: 41.9,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ZA]: {
          // ZA uses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 749,
            price: 749,
            pricePerMonth: 62.4,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 499.5,
            price: 999,
            pricePerMonth: 41.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.JP]: {
          // JP uses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 6500,
            price: 6500,
            pricePerMonth: 541,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 4900,
            price: 9800,
            pricePerMonth: 408,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
      }
    : {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 2988,
            price: 2988,
            pricePerMonth: 249,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 2220,
            price: 4440,
            pricePerMonth: 184.5,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/44331688067142',
            alternateVariantId: 'gid://shopify/ProductVariant/44331688067142',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 144,
            price: 144,
            pricePerMonth: 12,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 192,
            price: 96,
            pricePerMonth: 8,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/62359756374387',
            alternateVariantId: 'gid://shopify/ProductVariant/62359756374387',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40908419989564',
            alternateVariantId: 'gid://shopify/ProductVariant/40908419989564',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40200379727968',
            alternateVariantId: 'gid://shopify/ProductVariant/40200379727968',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },

        [ShopifyStore.EU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 36,
            price: 36,
            pricePerMonth: 3,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/40858437845065',
            alternateVariantId: 'gid://shopify/ProductVariant/40858437845065',
            checkouturl: '', // TODO
            pricePerYear: 27,
            price: 54,
            pricePerMonth: 2.3,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.AU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl: '', // TODO
            pricePerYear: 59,
            price: 59,
            pricePerMonth: 4.92,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl: '', // TODO
            pricePerYear: 44.5,
            price: 89,
            pricePerMonth: 3.71,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.CA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41616863887456',
            alternateVariantId: 'gid://shopify/ProductVariant/41616863887456',
            checkouturl: '', // TODO
            pricePerYear: 49,
            price: 49,
            pricePerMonth: 4.08,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41616864116832',
            alternateVariantId: 'gid://shopify/ProductVariant/41616864116832',
            checkouturl: '', // TODO
            pricePerYear: 39.5,
            price: 79,
            pricePerMonth: 3.29,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/40200379727968',
            alternateVariantId: 'gid://shopify/ProductVariant/40200379727968',
            checkouturl: '',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/50437365563710',
            alternateVariantId: 'gid://shopify/ProductVariant/50437365563710',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 155,
            price: 155,
            pricePerMonth: 12.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/50461136355646',
            alternateVariantId: 'gid://shopify/ProductVariant/50461136355646',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 99.5,
            price: 199,
            pricePerMonth: 16.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/50437365563710',
            alternateVariantId: 'gid://shopify/ProductVariant/50437365563710',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50437365563710:1',
            pricePerYear: 671,
            price: 671,
            pricePerMonth: 55.9,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/50461136355646',
            alternateVariantId: 'gid://shopify/ProductVariant/50461136355646',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/50461136355646:1',
            pricePerYear: 503,
            price: 1006,
            pricePerMonth: 41.9,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.ZA]: {
          // ZA uses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 749,
            price: 749,
            pricePerMonth: 62.4,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 499.5,
            price: 999,
            pricePerMonth: 41.6,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
        [ShopifyStore.JP]: {
          // JP uses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55281493967222',
            alternateVariantId: 'gid://shopify/ProductVariant/55281493967222',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281493967222:1',
            pricePerYear: 6500,
            price: 6500,
            pricePerMonth: 541,
            validityInYears: 1,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55281543381366',
            alternateVariantId: 'gid://shopify/ProductVariant/55281543381366',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/55281543381366:1',
            pricePerYear: 4900,
            price: 9800,
            pricePerMonth: 408,
            validityInYears: 2,
          },
          Month3: {
            variantId: 'gid://shopify/ProductVariant/49202073993534',
            alternateVariantId: 'gid://shopify/ProductVariant/49202073993534',
            checkouturl:
              'https://ultrahuman-eu-uk.myshopify.com/cart/49202073993534:1',
            pricePerYear: 0,
            price: 0,
            pricePerMonth: 0,
            validityInYears: 0.25,
          },
        },
      };

